<template>
  <div class="dormitory-container">
    <!-- 头部信息区域 -->
    <div class="header-section">

      <div class="header-left">
        <span class="header-title">智慧洗衣数据分析</span>
      </div>

      <div class="header-right">
        <label>开始日期：</label>
        <input class="form-input" type="date" v-model="query.startDate" placeholder="" />

        <span style="margin-right: 30px;"></span>

        <label>结束日期：</label>
        <input class="form-input" type="date" v-model="query.endDate" placeholder="" />

        <div v-if="showUpdateMessage" class="update-message">
          ✅ 数据已更新
        </div>
      </div>
      
    </div>

    <!-- 统计卡片区域 -->
    <div class="stats-section">
      <div class="stat-card blue">
        <div class="stat-icon blue">👥</div>
        <div class="stat-content">
          <div class="stat-number">{{ statsData.totalUsers || 0 }}</div>
          <div class="stat-label">总用户数</div>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon green">📋</div>
        <div class="stat-content">
          <div class="stat-number">{{ statsData.totalOrders || 0 }}</div>
          <div class="stat-label">订单总数</div>
        </div>
      </div>
      <div class="stat-card red">
        <div class="stat-icon red">⏰</div>
        <div class="stat-content">
          <div class="stat-number">{{ statsData.timeoutOrders || 0 }}</div>
          <div class="stat-label">超时订单</div>
        </div>
      </div>
      <div class="stat-card black">
        <div class="stat-icon black">🚫</div>
        <div class="stat-content">
          <div class="stat-number">{{ statsData.blacklistUsers || 0 }}</div>
          <div class="stat-label">黑名单</div>
        </div>
      </div>
    </div>

    <!-- 洗衣数据分析区域第一层 -->
    <div class="laundry-stats">
      <!-- 设备使用统计卡片 -->
      <div class="laundry-stats-card" style="margin-left: 10px;">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">设备使用统计</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload1" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting1 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting1" style="font-size: 12px; margin-left: 4px;">导出中...</span>
            </span>
          </div>
        </div>
        <div class="laundry-stats-pic">
          <div class="laundry-stats-pic-item">
            <!-- 空数据提示 -->
            <div v-if="!hasDeviceData" class="no-data-container">
              <div class="no-data-icon">📊</div>
              <div class="no-data-text">暂无设备使用数据</div>
            </div>
            <EchartsLineChart
              v-else
              ref="lineChartRef"
              :chart-data="deviceData"
              :time-data="timeRange"
              :show-title="false"
              :show-legend="true"
              height="100%"
              width="100%"
              :show-toolbox="false"
              :download-file-name="'设备使用统计'"
              :unit="'单位：单'"
              :y-max="yDeviceDataMaxValue"
            />
          </div>
        </div>
      </div>
      
      <!-- 洗衣程序使用统计卡片 -->
      <div class="laundry-stats-card">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">洗衣程序使用统计</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload2" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting2 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting2" style="font-size: 12px; margin-left: 4px;">导出中...</span>
            </span>
          </div>
        </div>
        <div class="laundry-stats-pic">
          <div class="laundry-stats-pic-item">
            <!-- 空数据提示 -->
            <div v-if="!hasProgramData" class="no-data-container">
              <div class="no-data-icon">📊</div>
              <div class="no-data-text">暂无洗衣程序数据</div>
            </div>
            <EchartsPieChart
              v-else
              ref="pieChartRef"
              title="洗衣程序分布"
              :chart-data="programData"
              :radius="['40%', '70%']"
              :center="['35%', '50%']"
              :show-legend="true"
              :legend-position="'right'"
              height="100%"
              width="100%"
              :show-toolbox="false"
              :download-file-name="'洗衣程序分布'"
            />
          </div>
        </div>
      </div>
      
      <!-- 投诉情况统计卡片 -->
      <div class="laundry-stats-card" style="margin-right: 10px;">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">投诉情况统计</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload3" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting3 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting3" style="font-size: 12px; margin-left: 4px;">导出中...</span>           
            </span>
          </div>
        </div>
        <div class="laundry-stats-pic" style="width: 100%; height: 90%; display: flex;flex-direction: column;align-items: center;">
          <div class="laundry-stats-pic-title">
            <div class="laundry-stats-pic-title-item">
              <span>投诉类型</span>
            </div>
            <div class="laundry-stats-pic-title-item"> 
              <span>投诉率</span>
            </div>
            <div class="laundry-stats-pic-title-item">
              <span>投诉情况</span>
            </div>
          </div>
          <div class="laundry-stats-pic-items">
            <div class="laundry-stats-pic-item1">
              <!-- 空数据提示 -->
              <div v-if="!hasComplaintTypeData" class="no-data-container small">
                <div class="no-data-icon">📊</div>
                <div class="no-data-text">暂无数据</div>
              </div>
              <EchartsDoughnutPieChart
                v-else
                ref="doughnutPieChartRef"
                title=""
                :chart-data="complaintTypeData"
                :show-legend="true"
                :legend-position="'bottom'"
                :radius="['25%', '45%']"
                :title-gap="0"
                :legend-gap="0"
                height="100%"
                width="100%"
                :show-toolbox="false"
                :show-label="false"
                :download-file-name="'投诉类型统计'"
                :show-legend-data="true"
                :legend-data-formatter="'{name}: {value} ({percent}%)'"
              />
            </div>
            <div class="laundry-stats-pic-item2">
              <!-- 空数据提示 -->
              <div v-if="!hasComplaintRateData" class="no-data-container small">
                <div class="no-data-icon">📊</div>
                <div class="no-data-text">暂无数据</div>
              </div>
              <EchartsDoughnutPieChart
                v-else
                title=""
                :chart-data="complaintRateData"
                :show-legend="true"
                :legend-position="'bottom'"
                :radius="['25%', '45%']"
                :title-gap="0"
                :legend-gap="0"
                height="100%"
                width="100%"
                :show-toolbox="false"
                :show-label="false"
                :download-file-name="'投诉率'"
                :show-legend-data="true"
                :legend-data-formatter="'{name}: {value} ({percent}%)'"
              />
            </div>
            <div class="laundry-stats-pic-item3">
              <span style="font-size: 18px; font-weight: bold; color: #666; margin-bottom: 10px;">
                投诉总数量
              </span>
              <span style="background: #e9ecef;font-weight: 500;display: flex;align-items: center;justify-content: center;width: 150px;height: 150px;font-size: 30px; margin-bottom: 15px;padding: 4px 10px; border-radius: 4px; margin-left: 10px;">
                {{ complaintStats.totalCount || 0 }} 次
              </span>
              <!-- <div style="display: flex; flex-direction: column; align-items: flex-start; font-size:18px;">
                <span style=" margin-bottom: 10px; margin-left: 10px;">✅ 已处理：{{ complaintStats.resolvedCount || 0 }}</span>
                <span style=" margin-bottom: 10px; margin-left: 10px;">🔁 处理中：{{ complaintStats.processingCount|| 0 }}</span>
                <span style=" margin-bottom: 10px; margin-left: 10px;">❌ 未处理：{{ complaintStats.pendingCount || 0 }}</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 洗衣数据分析区域第二层 -->
    <div class="laundry-stats">
      <!-- 订单时间分布卡片 -->
      <div class="laundry-stats-card" style="margin-left: 10px;margin-bottom: 10px;">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">订单时间分布</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload4" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting4 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting4" style="font-size: 12px; margin-left: 4px;">导出中...</span>
            </span>
          </div>
        </div>
        <div class="laundry-stats-pic">
          <div class="laundry-stats-pic-item">
            <!-- 空数据提示 -->
            <div v-if="!hasOrderTimeData" class="no-data-container">
              <div class="no-data-icon">📊</div>
              <div class="no-data-text">暂无订单时间分布数据</div>
            </div>
            <EchartsBarChart
              v-else
              ref="barChartRef"
              :chart-data="timeXData"
              :xAxisData="timeXData"  
              :seriesData="orderTimeData"
              :yAxisName="'单位：单'"
              :legendName="'订单数'"
              :title="''"
              :barColor="'#5470c6'"
              height="100%"
              width="100%"
              :show-toolbox="false"
              :download-file-name="'订单时间分布'"
            />
          </div>
        </div>
      </div>
      
      <!-- 用户行为分析卡片 -->
      <div class="laundry-stats-card" style="margin-bottom: 10px;">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">用户行为分析</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload5" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting5 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting5" style="font-size: 12px; margin-left: 4px;">导出中...</span>
            </span>
          </div>
        </div>
        <div class="laundry-stats-pic">
          <div class="laundry-stats-pic-item">
            <!-- 空数据提示 -->
            <div v-if="!hasUserBehaviorData" class="no-data-container">
              <div class="no-data-icon">📊</div>
              <div class="no-data-text">暂无用户行为数据</div>
            </div>
            <EchartsRoseChart
              v-else
              ref="roseChartRef"
              :chart-data="userBehaviorData"
              title=" "
              :backgroundColor="'#fff'"
              :title-color="'#000'"
              :rose-type="'area'"
              :radius="'65%'"
              width="100%"
              height="100%"
              :show-toolbox="false"
              :download-file-name="'用户行为分析图'"
            />
          </div>
        </div>
      </div>
      
      <!-- 用户取消原因卡片 -->
      <div class="laundry-stats-card" style="margin-right: 10px;margin-bottom: 10px;">
        <div class="laundry-stats-title">
          <div class="laundry-stats-label">用户取消原因</div>
          <div class="laundry-stats-icon">
            <span 
              @click="handleDownload6" 
              style="cursor: pointer; font-size: 16px;"
              :class="{ 'export-disabled': isExporting6 }"
              title="导出图表数据"
            >
              📥
              <span v-if="isExporting6" style="font-size: 12px; margin-left: 4px;">导出中...</span>
            </span>
          </div> 
        </div>
        <div class="laundry-stats-pic">
          <div class="laundry-stats-pic-item">
            <!-- 空数据提示 -->
            <div v-if="!hasCancelReasonData" class="no-data-container">
              <div class="no-data-icon">📊</div>
              <div class="no-data-text">暂无取消原因数据</div>
            </div>
            <EchartsHalfPieChart
              v-else
              ref="halfPieChartRef"
              :chart-data="cancelReasonData"
              title=" "
              :radius="['40%', '80%']"
              :center="['50%', '70%']"
              :start-angle="180"
              :end-angle="360"
              :legend-position="'none'"
              :label-position="'outside'"
              :colors="['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE']"
              width="100%"
              height="100%"
              :show-toolbox="false"
              :download-file-name="'用户取消原因'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入统计图
import EchartsLineChart from '@/components/EchartsLineChart.vue';
import EchartsPieChart from '@/components/EchartsPieChart.vue';
import EchartsBarChart from '@/components/EchartsBarChart.vue';
import EchartsDoughnutPieChart from '@/components/EchartsDoughnutPieChart.vue';
import EchartsRoseChart from '@/components/EchartsRosePieChart.vue';
import EchartsHalfPieChart from '@/components/EchartsHalfPieChart.vue';

// 导入接口
import { 
  getOverviewStats, //总览统计
  getDeviceUsageStats,//设备使用统计
  getWashProgramDistribution, //洗衣程序分布
  getComplaintStats,//投诉统计
  getOrderTimeDistribution,//订单时间分布
  getUserBehaviorAnalysis,//用户行为分析
  getOrderCancelReasonAnalysis,//用户取消原因
  exportChartData, //导出图表数据
} from '@/api/laundry';

// 导入工具函数
import { downloadFile } from '@/api/download';
import { formatDateForApi,setDefaultDateRange,validateDateRange } from '@/api/dateValidator';

export default {
  name: 'LaundryStatistics',

  components: {
    EchartsLineChart,
    EchartsPieChart,
    EchartsBarChart,
    EchartsDoughnutPieChart,
    EchartsRoseChart,
    EchartsHalfPieChart
  },

  data() {
    return {
      // 导出状态（独立控制）
      isExporting1: false, // 设备使用统计导出状态
      isExporting2: false, // 洗衣程序使用统计导出状态
      isExporting3: false, // 投诉情况统计导出状态
      isExporting4: false, // 订单时间分布导出状态
      isExporting5: false, // 用户行为分析导出状态
      isExporting6: false, // 用户取消原因导出状态

      // 时间选择
      query: {
        startDate: '', // 开始日期
        endDate: '' // 结束日期
      },

      // 加载状态
      loading: false, // 总览统计
      showUpdateMessage: false, // 数据更新提示
      updateMessageTimer: null, // 数据更新提示计时器

      // 统计数据
      statsData: {
        totalUsers: 0, //总用户数
        totalOrders: 0, //订单总数
        timeoutOrders: 0, //超时订单
        blacklistUsers: 0 //黑名单
      }, 
      
      // 设备使用统计数据
      timeRange: [], // 时间范围
      deviceData: [], // 设备使用数据

      // 洗衣程序使用统计数据
      programData: [],

      // 投诉情况统计数据
      complaintTypeData: [], // 投诉类型统计
      complaintRateData: [], // 投诉率统计

      // 投诉处理情况
      complaintStats: {
        totalCount: 0,       // 投诉总数量
        resolvedCount: 0,    // 已处理
        processingCount: 0,  // 处理中
        pendingCount: 0      // 未处理
      },

      // 订单时间分布数据
      timeXData: [],         // 时间
      orderTimeData: [],     // 订单数

      // 用户行为分析数据
      userBehaviorData: [],

      // 用户取消原因数据
      cancelReasonData: [],
      
      // 计时器
      debounceTimer: null,  // 新增：防抖计时器
      resizeTimer: null,    // 新增：窗口缩放防抖计时器
      lastQueryParams: null, // 新增：上一次请求参数

    }
  },  

  // 计算属性
  computed: {

    // 设备使用统计图表y轴最大值
    yDeviceDataMaxValue() {
      let max = 0;
      this.deviceData.forEach(item => {
        item.data.forEach(value => {
          if (value > max) {
            max = value;
          }
        });
      });
      return max;
    },

    // 检查查询的时间范围是否有效
    isQueryValid() {
      return this.query.startDate && this.query.endDate;
    },

    // 生成当前查询的时间字符串
    currentQueryString() {
      return `${this.query.startDate}_${this.query.endDate}`;
    },

    // 设备使用统计是否有数据
    hasDeviceData() {
      return this.deviceData && this.deviceData.length > 0 
    },
    // 下面代码返回数据为0的时候不显示
    // hasDeviceData() {
    //   return this.deviceData && 
    //          this.deviceData.length > 0 && 
    //          this.deviceData.some(item => item.data && item.data.some(val => val > 0));
    // },

    // 洗衣程序是否有数据
    hasProgramData() {
      return this.programData && this.programData.length > 0 
    },
    // hasProgramData() {
    //   return this.programData && 
    //          this.programData.length > 0 && 
    //          this.programData.some(item => item.value > 0);
    // },

    // 投诉类型是否有数据
    hasComplaintTypeData() {
      return this.complaintTypeData && this.complaintTypeData.length > 0 
    },
    // hasComplaintTypeData() {
    //   return this.complaintTypeData && 
    //          this.complaintTypeData.length > 0 && 
    //          this.complaintTypeData.some(item => item.value > 0);
    // },
    // 投诉率是否有数据
    hasComplaintRateData() {
      return this.complaintRateData && this.complaintRateData.length > 0 
    },
    // hasComplaintRateData() {
    //   return this.complaintRateData && 
    //          this.complaintRateData.length > 0 && 
    //          this.complaintRateData.some(item => item.value > 0);
    // },

    // 订单时间分布是否有数据
    hasOrderTimeData() {
      return this.orderTimeData && this.orderTimeData.length > 0 
    },
    // hasOrderTimeData() {
    //   return this.orderTimeData && 
    //          this.orderTimeData.length > 0 && 
    //          this.orderTimeData.some(val => val > 0);
    // },

    // 用户行为分析是否有数据
    hasUserBehaviorData() {
      return this.userBehaviorData && this.userBehaviorData.length > 0 
    },
    // hasUserBehaviorData() {
    //   return this.userBehaviorData && 
    //          this.userBehaviorData.length > 0 && 
    //          this.userBehaviorData.some(item => item.value > 0);
    // },

    // 用户取消原因是否有数据
    hasCancelReasonData() {
      return this.cancelReasonData && this.cancelReasonData.length > 0
    }
    // hasCancelReasonData() {
    //   return this.cancelReasonData && 
    //          this.cancelReasonData.length > 0 && 
    //          this.cancelReasonData.some(item => item.value > 0);
    // }
  },

  watch: {
    // 监听开始日期
    'query.startDate'(newVal, oldVal) {
      console.log('开始日期变化:', { 新值: newVal, 旧值: oldVal });
      if (newVal !== oldVal && this.query.endDate) {
        this.debounceFetch();
      }
    },
    // 监听结束日期
    'query.endDate'(newVal, oldVal) {
      console.log('结束日期变化:', { 新值: newVal, 旧值: oldVal });
      if (newVal !== oldVal && this.query.startDate) {
        this.debounceFetch();
      }
    }
  },


  // 生命周期钩子
  mounted() {

    // 设置默认日期7天范围
    const defaultDateRange = setDefaultDateRange(30); // 最近30天
    this.query = { ...this.query, ...defaultDateRange };
    console.log(`数据laundry_headers:`,localStorage.getItem('laundry_headers'));
    // 获取全部数据
    this.fetchAllData();
    
    // 监听窗口缩放事件，适配ECharts
    window.addEventListener('resize', this.handleWindowResize);
  },

  // 组件销毁
  beforeDestroy() {
    // 清理所有计时器
    if (this.debounceTimer) clearTimeout(this.debounceTimer); //清理防抖计时器
    if (this.updateMessageTimer) clearTimeout(this.updateMessageTimer); //清理数据更新提示计时器
    if (this.resizeTimer) clearTimeout(this.resizeTimer); //清理窗口缩放防抖计时器
    // 移除窗口缩放监听
    window.removeEventListener('resize', this.handleWindowResize);
  },

  // 方法
  methods: {

    // 防抖获取数据
    debounceFetch() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      
      this.debounceTimer = setTimeout(() => {
        this.handleDateChange();
      }, 500);
    },

    // 日期变化处理函数
    handleDateChange() {
      if (!this.isQueryValid) {
        console.warn('日期选择不完整');
        return;
      }
      
      const queryString = this.currentQueryString;
      if (this.lastQueryParams === queryString) {
        console.log('参数未变化');
        return;
      }
      
      console.log('开始验证日期');
      // 验证日期范围(最大90天)
      const isValid = validateDateRange(
        this.query, // 日期对象（startDate/endDate）
        this.showMessage, // 提示方法
        90 // 最大天数（可选，默认90）
      );
      if (isValid) {
        console.log('日期有效，获取数据');
        this.fetchAllData();
      }
    },

    // 窗口缩放处理（防抖）
    handleWindowResize() {
      // 防抖：避免频繁触发重绘
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        try {
          // 通知所有ECharts实例重绘（适配新尺寸）
          Object.keys(this.$refs).forEach(refName => {
            const chartRef = this.$refs[refName];
            if (chartRef && typeof chartRef.resize === 'function') {
              chartRef.resize();
            }
          });
        } catch (error) {
          // 捕获缩放时的DOM异常，避免页面报错
          console.warn('图表缩放适配失败:', error);
        }
      }, 100); // 100ms防抖，平衡响应速度和性能
    },

    // 显示更新成功提示
    showUpdateSuccess() {
      if (this.updateMessageTimer) clearTimeout(this.updateMessageTimer);  // 清理上一次提示
      this.showUpdateMessage = true;  // 显示提示
      // 3s后自动关闭提示
      this.updateMessageTimer = setTimeout(() => {
        this.showUpdateMessage = false;
      }, 3000);
    },

    // 手动关闭提示
    closeUpdateMessage() {
      this.showUpdateMessage = false;// 关闭提示
      // 清理计时器
      if (this.updateMessageTimer) {
        clearTimeout(this.updateMessageTimer);
        this.updateMessageTimer = null;
      }
    },
    
    // 获取所有数据
    async fetchAllData() {
      // if (!this.isQueryValid) {
      //   this.showMessage('请选择开始日期和结束日期');
      //   return;
      // }
      
      try {
        this.loading = true;
        console.log('开始获取数据，参数：', this.query);
        
        const startTime = new Date().getTime(); // 开始时间戳

        // 等待所有接口调用完成
        await Promise.allSettled([
          this.fetchStatsData(), // 1.1 顶部统计卡片
          this.fetchDeviceUseData(), // 1.2 设备使用统计
          this.fetchLaundryUseData(), // 1.3 洗衣程序统计
          this.fetchComplaintData(), // 1.4 投诉情况统计
          this.fetchOrderTimeData(), // 1.5 订单时间分布
          this.fetchUserBehaviorData(), // 1.6 用户行为分析
          this.fetchCancelReasonData() // 1.7 用户取消原因
        ]);
        
        const endTime = new Date().getTime();
        console.log(`数据更新完成，耗时：${endTime - startTime}ms`);

        // 关键修改：确保更新提示显示
        this.showUpdateSuccess(); 
        this.lastQueryParams = this.currentQueryString; // 记录最新查询参数
        
      } catch (error) {
        console.error('数据更新全局异常:', error);
        this.showMessage('数据更新异常，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    

    // 1.1 获取顶部统计卡片数据(ok)
    async fetchStatsData() {
      try {
        const response = await getOverviewStats(this.query);
        //看这个请求的header
        console.log(`请求头：`,response.headers);
        
        const res = response.data;
        if (res.code === 0) {
          this.statsData = {
            totalUsers: res.data.totalUsers,
            totalOrders: res.data.totalOrders,
            timeoutOrders: res.data.overtimeOrders,        
            blacklistUsers: res.data.blacklistUsers 
          };
        } else {
          //alert('获取统计数据失败：' + res.message);
          console.log('获取统计数据失败：', res.message);
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        // alert('网络异常，请稍后重试');
        this.statsData = {
          totalUsers: "0",
          totalOrders: "0",
          timeoutOrders: "0",
          blacklistUsers: "0"
        };
      }
    },

    // 1.2 获取设备使用统计数据
    async fetchDeviceUseData() {
      try {
        const response = await getDeviceUsageStats(this.query);
        const res = response.data;
        if (res.code === 0) {
          this.timeRange = res.data.timePoints;
          this.deviceData = res.data.series.map(item => ({
            name: item.deviceId,
            data: item.data
          }));
        } else {
          //alert('获取设备使用数据失败：' + res.message);
          console.log('获取设备使用数据失败：', res.message);
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.timeRange = this.getDefaultTimePoints();
        this.deviceData = this.getDefaultDeviceData();
      }
    },

    // 1.3 获取洗衣程序使用统计数据
    async fetchLaundryUseData() {
      try {
        const response = await getWashProgramDistribution(this.query);
        const res = response.data;
        if (res.code === 0) {
          this.programData = res.data.programs.map(item => ({
            value: item.count,
            name: item.programName
          }));
        } else {
          //alert('获取洗衣程序数据失败：' + res.message);
          console.log('获取洗衣程序数据失败：', res.message);
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.programData = this.getDefaultProgramData();
      }
    },

    // 1.4 获取投诉情况统计数据
    async fetchComplaintData() {
      try {
        const response = await getComplaintStats(this.query);
        const res = response.data;
        if (res.code === 0) {

          // 投诉类型统计
          this.complaintTypeData = res.data.typeDistribution.map(item => ({
            value: item.count,
            name: item.typeName
          }));

          // 清空原有投诉率数据，避免累加
          this.complaintRateData = [];
          // 投诉率统计
          const orderCount = res.data.orderCount;// 订单总数
          const complaintCount = res.data.complaintCount;// 投诉总数
          const nomalCount = orderCount - complaintCount;// 正常订单总数
          this.complaintRateData.push({ value: nomalCount, name: '正常订单', color: '#91CC75' });
          this.complaintRateData.push({ value: complaintCount, name: '投诉订单', color: '#EE6666' });
          
          // 投诉处理情况
          this.complaintStats = {
            totalCount: res.data.complaintCount,
            // resolvedCount: res.data.processStatus.processed,
            // processingCount: res.data.processStatus.processing,
            // pendingCount: res.data.processStatus.pending
          };
        } else {
          //alert('获取投诉数据失败：' + res.message);
          console.log('获取投诉数据失败：', res.message);
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.complaintTypeData = this.getDefaultComplaintTypeData();
        this.complaintRateData = this.getDefaultComplaintRateData();
        this.complaintStats = { 
          totalCount: 0, 
          resolvedCount: 0, 
          processingCount: 0, 
          pendingCount: 0 
        };
      }
    },

    // 1.5 获取订单时间分布数据
    async fetchOrderTimeData() {
      try {
        const response = await getOrderTimeDistribution(this.query);
        const res = response.data;
        if (res.code === 0) {
          this.timeXData = res.data.timePoints;
          this.orderTimeData = res.data.orderCounts;
        } else {
         // alert('获取订单时间分布数据失败：' + res.message);
          console.log('获取订单时间分布数据失败：', res.message);
          
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.timeXData = this.getDefaultTimePoints();
        this.orderTimeData = this.getDefaultOrderCounts();
      }
    },

    // 1.6 获取用户行为分析数据(ok)
    async fetchUserBehaviorData() {
      try {
        const response = await getUserBehaviorAnalysis(this.query);
        const res = response.data;
        if (res.code === 0) {
          this.userBehaviorData = res.data.behaviors.map(item => ({
            value: item.count,
            name: item.behaviorName
          }));
        } else {
          //alert('获取用户行为数据失败：' + res.message);
          console.log('获取用户行为数据失败：', res.message);
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.userBehaviorData = this.getDefaultUserBehaviorData();
      }
    },

    // 1.7 获取用户取消原因数据
    async fetchCancelReasonData() {
      try {
        const response = await getOrderCancelReasonAnalysis(this.query);
        const res = response.data;
        if (res.code === 0) {
          // 过滤掉 count 为 0 的数据
          const filteredData = res.data.reasons
            .filter(item => item.count > 0)  // 只保留 count > 0 的数据
            .map(item => ({
              value: item.count,
              name: item.reasonName
            }));
          
          // 如果过滤后没有数据，使用空数组（将显示"暂无数据"提示）
          this.cancelReasonData = filteredData;
          
          console.log('处理后的取消原因数据:', this.cancelReasonData);
        } else {
          console.log('获取用户取消原因数据失败：', res.message);
          //alert('获取用户取消原因数据失败：' + res.message);
          this.cancelReasonData = [];
        }
      } catch (error) {
        console.error('接口调用出错:', error);
        this.cancelReasonData = [];
      }
    },

    // 默认数据方法
    getDefaultDeviceData() {
      return [
        { name: '设备1', data: [5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5] },
        { name: '设备2', data: [10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10] },
        { name: '设备3', data: [15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15] },
        { name: '设备4', data: [20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20] }
      ];
    },

    getDefaultProgramData() {
      return [
        { value: 50, name: '桶自洁5分钟'},
        { value: 50, name: '单脱水6分钟'},
        { value: 50, name: '快洗25分钟'},
        { value: 50, name: '标准洗35分钟'},
        { value: 50, name: '大件洗45分钟'}
      ];
    },

    getDefaultComplaintTypeData() {
      return [
        { value: 50, name: '超时'},
        { value: 50, name: '违禁品'}
      ];
    },

    getDefaultComplaintRateData() {
      return [
        { value: 50, name: '正常订单', color: '#91CC75' },
        { value: 50, name: '投诉订单', color: '#EE6666' }
      ];
    },

    getDefaultTimePoints() {
      return ['6:00','7:00','8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'];
    },

    getDefaultOrderCounts() {
      return [5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];
    },

    getDefaultUserBehaviorData() {
      return [
        { value: 10, name: '正常'},
        { value: 10, name: '违规'}
      ];
    },

    getDefaultCancelReasonData() {
      return [
        { value: 100, name: '时间' },
        { value: 100, name: '数量' },
        { value: 100, name: '个人' },
        { value: 100, name: '占用' },
        { value: 100, name: '其他' }
      ];
    },

    // 消息提示
    showMessage(message) {
      alert(message);
    },

    // 1.8 通用导出方法
    async exportChart(chartType, loadingKey) {
      try {
        this[loadingKey] = true;
        if (!this.query.startDate || !this.query.endDate) {
          alert('❌ 请先选择开始日期和结束日期！');
          return;
        }

        const startDate = formatDateForApi(this.query.startDate);
        const endDate = formatDateForApi(this.query.endDate);

        //入参
        const exportParams = {
          chartType: chartType,
          startDate: startDate,
          endDate: endDate, 
          format: 'EXCEL' //**format 枚举**：`EXCEL` / `CSV` / `PDF`
        };

        const response = await exportChartData(exportParams);
        const res = response.data;

        if (res.code === 0 && res.data) {
          this.showMessage('报表导出成功，开始下载', 'success');
          if (res.data.fileUrl) {
            downloadFile(res.data.fileUrl, res.data.fileName, res.data.expiresAt);
            alert(`✅ 导出成功！文件将在新窗口中下载！`);
          } else if (res.data.url) {
            window.open(res.data.url);
          } else {
            this.showMessage('导出成功，但未找到下载链接', 'warning');
          }
        }else {
          this.showMessage('报表导出失败：' + (res.msg || '未知错误'), 'error');
        }

      } catch (error) {
        alert(`❌ 导出失败：${error.message || '服务器异常，请稍后重试'}`);
      } finally {
        this[loadingKey] = false;
      }
    },

    // 导出方法
    //导出设备使用数据
    handleDownload1() {
      this.exportChart('DEVICE_USAGE', 'isExporting1');
    },
    //导出洗衣程序使用数据
    handleDownload2() {
      this.exportChart('WASH_PROGRAM', 'isExporting2');
    },
    //导出投诉数据
    handleDownload3() {
      this.exportChart('COMPLAINT_STATS', 'isExporting3');
    },
    //导出订单时间分布数据
    handleDownload4() {
      this.exportChart('ORDER_TIME', 'isExporting4');
    },
    //导出用户行为分析数据
    handleDownload5() {
      this.exportChart('USER_BEHAVIOR', 'isExporting5');
    },
    //导出用户取消原因数据
    handleDownload6() {
      this.exportChart('CANCEL_REASON', 'isExporting6');
    }
  }
}
</script>

<style scoped>
/* <!-- .dormitory-container {
  background: #f5f5f5;
  height: 100vh;
  font-family: 'Microsoft YaHei', sans-serif;
  box-sizing: border-box;
  overflow: hidden; 
} --> */
.dormitory-container {
  background: #f5f5f5;
  height: 100vh;
  font-family: 'Microsoft YaHei', sans-serif;
  box-sizing: border-box;
}

/* 功能导航 */
/* 头部信息区域 */
.header-section {
  width: 100%;
  /* height: 10%; */
  min-height: 60px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 12px 20px 12px 20px;
  position: relative;
  box-sizing: border-box;
}

/* 头部左侧标题区域 */
.header-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
}

.header-left {
  width: 70%;
  display: flex;
  align-items: flex-start;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

/* 头部右侧时间选择区域 */
.header-right {
  width: 30%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #333;
  position: relative;
}

/* 更新提示样式 */
.update-message {
  position: absolute;
  top: 60px;
  right: 0;
  background-color: #67C23A;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  animation: fadeInOut 3s ease-in-out;
  z-index: 1000;
}

/* 淡入淡出动画 */
@keyframes fadeInOut {
  0% { opacity: 0;transform: translateY(-10px); }
  20% { opacity: 1;transform: translateY(0); }
  80% { opacity: 1;transform: translateY(0); }
  100% { opacity: 0;transform: translateY(-10px); }
}

/* 内容 */
/* 统计卡片区域 */
.stats-section {
  background: #fff;
  padding: 0 20px 10px 20px;
  display: flex;
  gap: 20px;
}

/* 4个卡片区域 */
.stat-card {
  width: 25%;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 20px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  
}

/* 卡片背景颜色 */
.stat-card.blue { background: #e3f2fd; }

.stat-card.green { background: #e8f5e8; }

.stat-card.red { background: #ffebee; }

.stat-card.black { background: #e9ecef; }

/* 卡片图标区域 */
.stat-icon {
  font-size: 24px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 图标背景颜色 */
.stat-icon.blue { background: #5470C6; }

.stat-icon.green { background: #91CC75; }

.stat-icon.red { background: #EE6666; }

.stat-icon.black { background: #333333; }

/* 卡片标题区域 */
.stat-content { text-align: left; }

/* 卡片数字显示 */
.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

/* 卡片描述 */
.stat-label {
  font-size: 18px;
  color: #666;
}

/* 数据分析区域 */
.laundry-stats  {
  width: 100%;
  height: 420px;
  background: #fff;
  padding: 10px;
  display: flex;
  gap: 20px;
  /* border-bottom: 1px solid #e0e0e0; */
}
/* 数据分析区域卡片2行3列 */
.laundry-stats-card {
  width: 33.3%;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

/* 卡片内部标题区域 */
.laundry-stats-title{
  width: 100%;
  height:10%;
  min-height: 30px;
  display: flex;
  flex-direction: row;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  margin-bottom: 5px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

/* 标题区域左侧标题内容 */
.laundry-stats-label {
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  color: #666;
}
/* 标题区域右侧图标 */
.laundry-stats-icon {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 卡片内部图表显示区域 */
.laundry-stats-pic {
  width: 100%;
  height: 90%;
  min-height: 230px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 5px;
  box-sizing: border-box;
}

/* 卡片内部投诉类型显示区域分为标题和图表显示上下2部分 */
.laundry-stats-pic-title{
  width: 100%; 
  height: 15%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

/* 卡片内部投诉类型统计标题显示区域分为3个子项 */
.laundry-stats-pic-title-item{
  width: 33.3%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px; 
  font-weight: bold; 
  color: #666;
  border-bottom: 1px solid #e9ecef;
}

/* 卡片内部投诉类型统计图表显示区域分为3个子项 */
.laundry-stats-pic-items{
  width: 100%; 
  height: 85%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

/* 卡片内部投诉类型统计图表显示区域每个子项 */
.laundry-stats-pic-item1 {
  width: 33.3%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.laundry-stats-pic-item2 {
  width: 33.3%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.laundry-stats-pic-item3 {
  width: 33.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* 卡片内部统计图表显示区域1个子项（除投诉类型统计图表） */
.laundry-stats-pic-item {
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

/* 导出禁用样式 */
.export-disabled {
  cursor: not-allowed !important;
  color: #999 !important;
  opacity: 0.7;
}

/* 空数据提示容器 */
.no-data-container {
  width: 100%;
  height: 100%;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  border-radius: 4px;
  color: #999;
}

/* 小尺寸的空数据提示容器（用于投诉类型中的子图表） */
.no-data-container.small {
  min-height: 150px;
}

/* 空数据图标 */
.no-data-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

/* 空数据文字 */
.no-data-text {
  font-size: 16px;
  color: #999;
}
</style>